import VueronSprintContext from './context';

const useVueronSprint = () => VueronSprintContext.hook();

export default useVueronSprint;
